import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function SwipeRush() {
  // Scroll to top on mount
  useEffect(function () {
    window.scrollTo(0, 0);
  }, []);

  // Scroll reveal
  useEffect(function () {
    var elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    elements.forEach(function (el) { observer.observe(el); });
    return function () { observer.disconnect(); };
  }, []);

  var features = [
    {
      icon: '⚡',
      title: 'Fast-Paced Gameplay',
      desc: 'Quick rounds that keep you on your toes with addictive swipe mechanics and instant feedback.',
    },
    {
      icon: '🏆',
      title: 'Global Leaderboards',
      desc: 'Compete with players worldwide and climb the global rankings in real time.',
    },
    {
      icon: '🎯',
      title: 'Daily Challenges',
      desc: 'New challenges every day to test your skills, earn rewards, and keep the streak alive.',
    },
    {
      icon: '🎨',
      title: 'Beautiful Design',
      desc: 'Stunning visuals and smooth animations crafted for a fully immersive card-swiping experience.',
    },
    {
      icon: '🃏',
      title: 'Smart Card Matching',
      desc: 'Strategically swipe and match the right cards — a perfect blend of luck and skill.',
    },
    {
      icon: '🔔',
      title: 'Live Notifications',
      desc: 'Stay in the loop with real-time updates on leaderboard shifts, challenges, and rewards.',
    },
  ];

  return (
    <div className={'sr-page'}>

      {/* ── Hero ─────────────────────────────────────────────────────────── */}
      <section className={'sr-hero'}>
        <div className={'sr-hero-inner'}>
          <div className={'sr-hero-content'}>
            <span className={'sr-label'}>NA Tech Ventures</span>
            <h1 className={'sr-headline'}>
              Swipe.<br />
              Match.<br />
              <span className={'sr-headline-accent'}>Win.</span>
            </h1>
            <p className={'sr-tagline'}>
              A fast-paced card-swiping game where quick decisions and sharp
              instincts are your greatest assets. Rush your way to the top.
            </p>
            <div className={'sr-badges'}>
              <span className={'sr-badge'}>📱 Android</span>
              <span className={'sr-badge'}>🍎 iOS</span>
              <span className={'sr-badge'}>🎮 Free to Play</span>
            </div>
          </div>
          <div className={'sr-hero-logo'}>
            <img
              src={require('../images/swiperush-logo.png').default}
              alt={'SwipeRush'}
            />
          </div>
        </div>
        <div className={'sr-hero-glow'}></div>
      </section>

      {/* ── About ────────────────────────────────────────────────────────── */}
      <section className={'sr-about'}>
        <div className={'sr-container'}>
          <div className={'sr-section-header reveal'}>
            <span className={'u-label'}>About the Game</span>
            <h2>What is SwipeRush?</h2>
          </div>
          <p className={'sr-about-text reveal reveal-delay-1'}>
            SwipeRush is an exciting card-swiping game developed by NA Tech Ventures.
            Dive into a fast-paced world where quick decisions and sharp instincts
            are your greatest assets. Swipe through cards, match the right ones,
            and rush your way to the top of the leaderboard!
          </p>
        </div>
      </section>

      {/* ── Features ─────────────────────────────────────────────────────── */}
      <section className={'sr-features'}>
        <div className={'sr-container'}>
          <div className={'sr-section-header reveal'}>
            <span className={'u-label'}>Features</span>
            <h2>Why Players Love It</h2>
          </div>
          <div className={'sr-features-grid'}>
            {features.map(function (f, i) {
              return (
                <div className={'sr-feature-card reveal reveal-delay-' + ((i % 3) + 1)} key={i}>
                  <span className={'sr-feature-icon'}>{f.icon}</span>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── Legal ────────────────────────────────────────────────────────── */}
      <section className={'sr-legal'}>
        <div className={'sr-container'}>
          <div className={'sr-section-header reveal'}>
            <span className={'u-label'}>Legal</span>
            <h2>Policies &amp; Terms</h2>
          </div>
          <div className={'sr-legal-links reveal reveal-delay-1'}>
            <Link to={'/products/swiperush/privacy-policy'} className={'sr-legal-btn'}>
              Privacy Policy
            </Link>
            <Link to={'/products/swiperush/terms-of-service'} className={'sr-legal-btn sr-legal-btn--outline'}>
              Terms of Service
            </Link>
          </div>
        </div>
      </section>

      {/* ── Back ─────────────────────────────────────────────────────────── */}
      <div className={'sr-back'}>
        <Link to={'/'} className={'sr-back-link'}>
          ← Back to NA Tech Ventures Homepage | www.nuevoalture.com
        </Link>
      </div>

    </div>
  );
}

export default SwipeRush;
